// VENDOR
window.$ = window.jQuery = require('jquery');

// IONIC
import {
    IonicVue
} from '@ionic/vue';

// ELEMENT
// import ElementPlus from 'element-plus/es'
import ElementPlus from '@/components/Vendor/Element'

import VueGoogleAutocomplete from '@/components/Vendor/vue-google-autocomplete/VueGoogleAutocomplete'
import VueGoogleSuburbAutocomplete from '@/components/Vendor/vue-google-suburb-autocomplete/VueGoogleSuburbAutocomplete';
import VueGoogleSuburbAutocompleteForJobPostFilter from '@/components/Vendor/vue-google-suburb-autocomplete/VueGoogleSuburbAutocompleteForJobPostFilter';
import VueShepherd from '@/components/Vendor/Shepherd/Shepherd';


import TheMainMenu from './TheMainMenu/TheMainMenu.vue'

export {
    IonicVue,
    ElementPlus,
    TheMainMenu,
    VueGoogleAutocomplete,
    VueGoogleSuburbAutocomplete,
    VueGoogleSuburbAutocompleteForJobPostFilter
}

export default {
    install(app) {
        app.use(IonicVue)
        .use(ElementPlus)
        .use(VueShepherd)
    },
};